import { api } from '../createApi';
import { TagType } from '../TagType';
import { getPrimitiveParam } from '../utils';

const TAG_BY_LIST = { type: TagType.Groups, id: 'LIST' };
const TAG_BY_ID = (id: string) => ({ type: TagType.Groups, id });

api.enhanceEndpoints({
  addTagTypes: [TagType.Groups as TagType],
  endpoints: {
    getAllDocumentGroups: {
      providesTags: [TAG_BY_LIST],
    },
    getDocumentGroup: {
      providesTags: [TAG_BY_LIST],
    },
    addDocumentsToGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },
    addDocumentsToGroupLinkParent: {
      invalidatesTags: [TAG_BY_LIST],
    },
    createDocumentGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },
    removeDocumentInGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },
    editDocumentGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },
    deleteDocumentGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },

    // Document/Ticket groups endpoints
    getAllGroups: {
      providesTags: [TAG_BY_LIST],
    },
    getGroups: {
      providesTags: [TAG_BY_LIST],
    },
    getGroup: {
      providesTags: (_result, _error, id) => [TAG_BY_ID(getPrimitiveParam(id))],
    },
    createGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },
    updateGroup: {
      invalidatesTags: (_result, _error, arg) => [
        TAG_BY_ID(getPrimitiveParam(arg.id)),
        TAG_BY_LIST,
      ],
    },
    deleteGroup: {
      invalidatesTags: [TAG_BY_LIST],
    },
  },
});
